import React from 'react';
// import { StringWms } from '../../../assets/ts/StringWms.js';

//component
import WmsCheckBox from '../components/WmsCheckBox/WmsCheckBox.jsx';
import WmsDropdown from '../components/WmsDropdown/WmsDropdown.jsx';
import WmsCollapse from '../components/WmsCollapse/WmsCollapse.jsx';
import WmsContainer from '../components/WmsContainer/WmsContainer.jsx';

export class CustomersFormInventory extends React.Component {

    constructor(props) {

        super(props);

        this.translate = window.translate;
        this.defaultFacilityAssignToOptions = {
            Id: 0,
            Name: "Unspecified",
        };

        this.state = {
            Selector: 'Customer',
            facilitiesObjForC2User: [],
            options: {
                JobPriorityOptions: [
                    { value: 10, text: "10 (lowest)" },
                    { value: 9, text: "9" },
                    { value: 8, text: "8 (default)" },
                    { value: 7, text: "7" },
                    { value: 6, text: "6" },
                    { value: 5, text: "5" },
                    { value: 4, text: "4" },
                    { value: 3, text: "3" },
                    { value: 2, text: "2" },
                    { value: 1, text: "1 (highest)" },
                ],
                DaysOptions: [
                    { text: "60 Days", value: 60 },
                    { text: "90 Days", value: 90 },
                    { text: "120 Days", value: 120 },
                    { text: "180 Days", value: 180 },
                ],
            }
        };
    }

    handleOptionsChange = (event) => {

        let name = event.target.name;
        let parentObj = Object.assign({}, this.props.sharedCustomer.Options['CycleCount']);

        if (event.target.type == 'checkbox') {
            parentObj[name] = !this.props.sharedCustomer.Options['CycleCount'][name];
        } else {
            parentObj[name] = event.target.value;
        }

        let customerObj = Object.assign(
            {},
            this.props.sharedCustomer,
            {
                Options: Object.assign(
                    {},
                    this.props.sharedCustomer.Options,
                    {
                        CycleCount: parentObj
                    }
                )
            }
        );
        this.props.onCustomerDataset(customerObj);
    }
    handleAssignToOptionsChange = (event, facilityId, facilityName, dropdownOptions) => {
        let parentObj = Object.assign({}, this.props.sharedCustomer.Options['CycleCount']);
        const findIndex = parentObj.DefaultAssignees.findIndex(assignee => assignee.FacilityIdentifier.Id == facilityId);
        if(findIndex == -1) {
            parentObj.DefaultAssignees.push({
                FacilityIdentifier: {
                    Id: facilityId,
                    Name: facilityName
                },
                UserIdentifier: {
                    Name: dropdownOptions.find(option => option.Id == event.target.value).Name,
                    Id: event.target.value
                }
            });
        }else{
            parentObj.DefaultAssignees[findIndex].UserIdentifier.Id = event.target.value;
            parentObj.DefaultAssignees[findIndex].UserIdentifier.Name = dropdownOptions.find(option => option.Id == event.target.value).Name;
        }
        let customerObj = Object.assign(
            {},
            this.props.sharedCustomer,
            {
                Options: Object.assign(
                    {},
                    this.props.sharedCustomer.Options,
                    {
                        CycleCount: parentObj
                    }
                )
            }
        );
        this.props.onCustomerDataset(customerObj);
        console.log("event", event.target.value);
        console.log("facilityId", facilityId);
    }
    componentWillReceiveProps(nextProps) {
        if(this.props.facilityUserList.length != nextProps.facilityUserList.length) {
            let facilitiesObjForC2User = nextProps.defaultFacilitiesObjForC2User.map(facility => {
                return {
                    ...facility,
                    AssignToOptions: [this.defaultFacilityAssignToOptions, ...nextProps.facilityUserList.filter(user => user.Facilities && user.Facilities.includes(facility.Id))]
                }
            });
            this.setState({
                facilitiesObjForC2User: facilitiesObjForC2User
            });
        }
    }

    render() {
        const renderInventoryOptions = this.props.sharedCustomer.Options;
        const FFOFC2U = this.state.facilitiesObjForC2User[0];
        return (
            <div className="collapseCustomerTabContent_wrapper" id={'collapseInventory'} >
                <WmsCollapse
                    id={'collapseInventoryContent'}
                    headerLabel={this.translate('Window_Title_Label_Inventory') + " | " + this.translate('Label_Cycle_Count')}
                    showCollapseText={false}
                    showCollapseIcon={true}  >

                    <WmsContainer className="system-general-settings-wrapper">

                        <WmsCheckBox
                            id={'CycleCountEnabled'}
                            name={'CycleCountEnabled'}
                            wmsSelector={this.state.Selector + 'CycleCountEnabled'}
                            onChangeFunc={this.handleOptionsChange}
                            label={this.translate('Label_Automated_Item_based_Cycle_Count')}
                            checked={renderInventoryOptions.CycleCount.CycleCountEnabled}
                            value={renderInventoryOptions.CycleCount.CycleCountEnabled}
                        />
                        <span className="wms-component-small-description with-margin">
                            {this.translate('Label_Automated_Item_based_Cycle_Count_Description')}
                        </span>


                    </WmsContainer >

                    <WmsContainer title={this.translate('Label_Default_Settings')} className="default-settings-wrapper">
                        <span className="wms-component-small-description">
                            {this.translate('Label_Default_Settings_Description')}
                        </span>
                        <WmsDropdown
                            id="DefaultPriority"
                            name="DefaultPriority"
                            label={this.translate('Label_Cycle_count_Job_Priority')}
                            wmsSelector={this.state.Selector + "DefaultPriority"}
                            onChangeFunc={this.handleOptionsChange}
                            value={renderInventoryOptions.CycleCount.DefaultPriority || 8}
                            options={this.state.options.JobPriorityOptions}
                            valueField='value'
                            textField='text'
                            disabled={!renderInventoryOptions.CycleCount.CycleCountEnabled}
                            parentClassName='form_group'
                             />

                        <WmsCheckBox
                            id={"DefaultCollectMUAndTrackBys"}
                            name={"DefaultCollectMUAndTrackBys"}
                            wmsSelector={this.state.Selector + "DefaultCollectMUAndTrackBys"}
                            onChangeFunc={this.handleOptionsChange}
                            checked={renderInventoryOptions.CycleCount.DefaultCollectMUAndTrackBys}
                            disabled={!renderInventoryOptions.CycleCount.CycleCountEnabled}
                            label={this.translate("Label_Collect_MU_And_TrackBy")}
                            showToolTip={true}
                            tooltipText={
                            "If you choose not to collect track-by data as part of the audit, you cannot reconcile variances if any audited inventory has track-by data."
                            }
                        />
                        <div className="include-suggested-locations-wrapper">
                            <WmsCheckBox
                                id={"IncludeSuggestedLocations"}
                                name={"IncludeSuggestedLocations"}
                                wmsSelector={this.state.Selector + "IncludeSuggestedLocations"}
                                disabled={!renderInventoryOptions.CycleCount.CycleCountEnabled}
                                onChangeFunc={this.handleOptionsChange}
                                checked={renderInventoryOptions.CycleCount.IncludeSuggestedLocations}
                                label={this.translate("Label_Include_Suggested_Locations")}
                            />
                            <WmsDropdown
                                id="ItemHistorySize"
                                name="ItemHistorySize"
                                label={""}
                                wmsSelector={this.state.Selector + "ItemHistorySize"}
                                onChangeFunc={this.handleOptionsChange}
                                value={renderInventoryOptions.CycleCount.ItemHistorySize}
                                disabled={!renderInventoryOptions.CycleCount.CycleCountEnabled || !renderInventoryOptions.CycleCount.IncludeSuggestedLocations}
                                options={this.state.options.DaysOptions}
                                valueField='value'
                                textField='text'
                                parentClassName='form_group'
                                extraWrapperClass='include-suggested-item-history-dropdown'
                                />
                        </div>

                    </WmsContainer>
                    <WmsContainer title={this.translate('Label_Default_Assignment')} className="default-assignment-wrapper">
                        <span className="wms-component-small-description">
                            {this.translate('Label_Default_Assignment_Description')}
                        </span>
                        {this.state.facilitiesObjForC2User.length == 1 && (
                            <WmsDropdown
                                id="DefaultAssignees"
                                name="DefaultAssignees"
                                label={this.translate("Label_Assign_To")}
                                wmsSelector={this.state.Selector + "DefaultAssignees"}
                                onChangeFunc={(e) => this.handleAssignToOptionsChange(e, FFOFC2U.Id, FFOFC2U.Name, FFOFC2U.AssignToOptions)}
                                value={renderInventoryOptions.CycleCount.DefaultAssignees.find(assignee => assignee.FacilityIdentifier.Id == FFOFC2U.Id)?.UserIdentifier.Id}
                                options={FFOFC2U.AssignToOptions}
                                disabled={!renderInventoryOptions.CycleCount.CycleCountEnabled}
                                valueField='Id'
                                textField='Name'
                                parentClassName='form_group'
                                extraWrapperClass=''
                            />
                        )}
                        {this.state.facilitiesObjForC2User.length > 1 && (
                            <div className="assign-to-users-wrapper">
                                <div className="assign-to-user-wrapper-header">
                                    <span className="assign-to-user-wrapper-header-text">{this.translate("Label_Warehouse_Text")}</span>
                                    <span className="assign-to-user-wrapper-header-text">{this.translate("Label_Assign_To")}</span>
                                </div>
                                {this.state.facilitiesObjForC2User.map(facility => (
                                    <div className="assign-to-user-options-wapper" key={"assign-to-user-options-wapper-" + facility.Name}>
                                        <span className="assign-to-user-options-wapper-text">{facility.Name}</span>
                                        <WmsDropdown
                                            id="DefaultAssignees"
                                            name="DefaultAssignees"
                                            label={""}
                                            noLabel={true}
                                            wmsSelector={this.state.Selector + "DefaultAssignees"}
                                            onChangeFunc={(e) => this.handleAssignToOptionsChange(e, facility.Id, facility.Name, facility.AssignToOptions)}
                                            value={renderInventoryOptions.CycleCount.DefaultAssignees.find(assignee => assignee.FacilityIdentifier.Id == facility.Id)?.UserIdentifier.Id}
                                            options={facility.AssignToOptions}
                                            disabled={!renderInventoryOptions.CycleCount.CycleCountEnabled}
                                            valueField='Id'
                                            textField='Name'
                                            parentClassName='form_group'
                                            extraWrapperClass=''
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </WmsContainer>
            </WmsCollapse >
            </div>
        );
    }
}